import { RootState } from '../../../../../init-store';
import { isYandexSsoUserSelector, isYandexTeamUserSelector } from '../../../../shared/features/user/selectors';

export const selectUserFeedback = (state: RootState) => state.userFeedback;
export const selectHasSummarizationFeedbackChatSection = (state: RootState) =>
    isYandexSsoUserSelector(state) || isYandexTeamUserSelector(state);
